import { copyLink } from '../Utils/copy-link';
import { openQRDialog } from '../Utils/qr-dialog';

/**
 * In the PDP QR Code popover, we have a copy link button. Handle that here.
 * Also wire up the QR image to open in the enlarged dialog on click.
 */
document.addEventListener( 'DOMContentLoaded', () => {
	const shareImgWrapper = document.querySelector( '.js-qala-qr-codes-woo-product-share-img-container' );

	if ( ! shareImgWrapper ) {
		return;
	}

	copyLink();

	const qrImg = shareImgWrapper.querySelector( '.qala-qr-codes__woo-product-share-img' );

	if ( qrImg && ! ( 'noDialog' in qrImg.dataset ) ) {
		qrImg.addEventListener( 'click', () => openQRDialog( qrImg.src ) );
	}
} );
